import loadable from '@loadable/component';

export const SavedSearchRedirectPageLoadable = loadable(
  () => import('./SavedSearchRedirectPage'),
  {
    resolveComponent: (module) => module.SavedSearchRedirectPage,
    ssr: false,
  },
);
